/**
 * The format shipped before per-record storage: every section of
 * UnifiedAppData in one JSON blob under LEGACY_DATA_KEY in AsyncStorage
 * (localStorage on web), at schema 2 or 3. It is read once, migrated, and
 * left in place as a fallback; recovery points the store back at it. A
 * session that can't use the per-record store saves here instead.
 *
 * TODO(2026-10-05): after one release on per-record storage, delete the
 * legacy blob once the migration marker is set.
 */
import AsyncStorage from "@react-native-async-storage/async-storage";

export const LEGACY_DATA_KEY = "synapse_unified_data_v2";
export const BACKUP_PREFIX = "synapse_backup_";
export const CORRUPTED_BACKUP_PREFIX = "synapse_backup_corrupted_";

/** The legacy blob, or null if there is none. Rejects if storage can't be read. */
export const readLegacyBlob = (): Promise<string | null> =>
  AsyncStorage.getItem(LEGACY_DATA_KEY);

/**
 * Fallback for a session whose per-record store can't be used: write the
 * whole state in the shipped format (slim history), so a later migration
 * picks it up. Never called once the migration marker is stored.
 */
export const writeLegacyBlob = (data: unknown): Promise<void> =>
  AsyncStorage.setItem(LEGACY_DATA_KEY, JSON.stringify(data));

/**
 * Copy unreadable stored data aside before anything may replace it.
 * Returns false if the copy could not be written.
 */
export async function backupCorrupted(
  raw: unknown,
  label?: string,
): Promise<boolean> {
  try {
    const key = `${CORRUPTED_BACKUP_PREFIX}${label ? `${label}_` : ""}${Date.now()}`;
    await AsyncStorage.setItem(
      key,
      typeof raw === "string" ? raw : JSON.stringify(raw),
    );
    console.log(`📦 Backed up unreadable data to ${key}`);
    return true;
  } catch (error) {
    console.error("🚨 Could not back up unreadable data:", error);
    return false;
  }
}
